import { Component, Input } from '@angular/core';
import { SupportsUtils } from '../../utils/supports/supports.utils';

@Component({
  selector: 'mp-functionnal-error-label',
  templateUrl: './mp-functionnal-error-label.component.html',
})
export class MpFuncionnalErrorLabelComponent {
  @Input() public error: string;
  @Input() public variable: string[];

  public getSupport(variable: string) {
    return SupportsUtils.labelAllSupportTypeSing[variable];
  }

  public getSupportQuality(variable: string) {
    return SupportsUtils.labelSupportQualitySing[variable];
  }
}
